const FunctionalErrorMessage = ({ message, id }) => {
  return <p id={id}>{message}</p>;
};

export default FunctionalErrorMessage;
